import { render, staticRenderFns } from "./UserEdit.vue?vue&type=template&id=533a4f2d"
import script from "./UserEdit.vue?vue&type=script&lang=js"
export * from "./UserEdit.vue?vue&type=script&lang=js"
import style0 from "./UserEdit.vue?vue&type=style&index=0&id=533a4f2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports